import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const VerifyPasswordEmailDoneComponent = (props: any) => {
  const navigate = useNavigate();
  return (
    <main className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full px-6 py-8 bg-white shadow-lg rounded-lg">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#FFF0F0] rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-[#CF3688]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">비밀번호 변경 완료</h2>
          <p className="text-gray-600">
            {getLanguageValue(
              PAGE_TYPE.COMMON,
              "verifyPasswordEmailDone.txtPasswordResetSuccess"
            )}
          </p>
        </div>

        <div className="mt-8">
          <button
            onClick={(e) => {
              navigate("/login");
            }}
            className="w-full py-3 px-4 bg-[#CF3688] hover:bg-[#B82E77] text-white font-medium rounded-md transition duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#CF3688] focus:ring-opacity-50"
          >
            {getLanguageValue(
              PAGE_TYPE.COMMON,
              "verifyPasswordEmailDone.btnLogin"
            )}
          </button>
        </div>
      </div>
    </main>
  );
};
export default VerifyPasswordEmailDoneComponent;
